import { mockLandingQuickStarts } from "@/lib/mock-data";

interface QuickStartCardsProps {
  onSelect?: (prompt: string) => void;
}

export function QuickStartCards({ onSelect }: QuickStartCardsProps) {
  return (
    <section className="mb-10" aria-labelledby="quick-start-heading">
      <div className="mb-5 flex flex-col gap-1 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h2
            id="quick-start-heading"
            className="text-sm font-semibold text-[var(--text-primary)]"
          >
            Quick-start paths
          </h2>
          <p className="mt-1 text-xs text-[var(--text-tertiary)]">
            Pick a preset to frame the assessment—still mock navigation for the POC.
          </p>
        </div>
      </div>
      <ul className="grid gap-4 sm:grid-cols-2">
        {mockLandingQuickStarts.map((item) => (
          <li key={item.id}>
            <button
              type="button"
              onClick={() => onSelect?.(item.prompt || item.description)}
              className="group flex h-full w-full flex-col text-left rounded-xl border border-[var(--border-subtle)] bg-[var(--bg-elevated)] p-4 shadow-[var(--shadow-card)] transition hover:border-[color-mix(in_srgb,var(--brand-primary)_45%,var(--border-subtle))] hover:bg-[var(--bg-muted)]"
            >
              <span className="text-sm font-semibold text-[var(--text-primary)] group-hover:text-[var(--brand-primary)]">
                {item.title}
              </span>
              <p className="mt-2 flex-1 text-xs leading-relaxed text-[var(--text-secondary)]">
                {item.description}
              </p>
              <span className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-[var(--brand-primary)]">
                Use this preset
                <span aria-hidden className="transition group-hover:translate-x-0.5">
                  →
                </span>
              </span>
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
